import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  margin: 100px auto;
  justify-content: center;
  align-items: center;

  font-family: 'Source Sans Pro', sans-serif;

  & > div {
    margin-bottom: 3em;
  }
`
